import { Component, Prop, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

const Locations = namespace('locations');
const Markers = namespace('markers');

@Component
export default class LocationPanelState extends Vue {
    @Locations.Getter
    activeLocationPanelItem!: string | null;

    @Locations.Getter
    mobileMenuOpened!: boolean | null;

    @Locations.Mutation
    setActiveLocationPanelItem!: (id: string | null) => void;

    @Locations.Mutation
    toggleMobileMenu!: () => void;

    @Markers.Mutation
    setActiveMarkerCategory!: (categoryId: string | null) => void;

    @Prop({ type: String, required: true })
    title!: string;

    @Prop({ type: Number, required: false, default: null })
    counter!: number;

    @Prop({ type: String, required: true })
    id!: string;

    @Prop({ type: String, required: false })
    color!: string;

    @Prop({ type: String, required: false })
    iconUrl!: string;

    @Prop({ type: String, required: false })
    introText!: string;

    @Prop({ type: Boolean, required: false, default: false })
    isAboutItem!: boolean;

    public get isActiveItem(): boolean {
        return this.activeLocationPanelItem === this.id;
    }
}
